import {Data} from '@store/@types/util';

export type DepartmentId = string;
interface DepartmentInterface {
  id: DepartmentId;
  name: string;
  cardsProfileId: string;
  filterWordsProfileId: string;
  // TODO types
  archivingProfileId: null;
  internalSharesPermission: string;
  externalSharesPermission: string;
  processTwoPartyConsentCalls: string;
}

export default class Department extends Data<DepartmentInterface>({
  id: null,
  name: null,
  cardsProfileId: null,
  filterWordsProfileId: null,
  archivingProfileId: null,
  internalSharesPermission: null,
  externalSharesPermission: null,
  processTwoPartyConsentCalls: null,
}) {}
